"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REPORTING = exports.LINEITEMS = exports.PRODUCTS = exports.QUOTES = exports.LISTS = exports.SETTINGS = exports.COMMUNICATOR = exports.CALLING = exports.CRM = void 0;
var CRM = 'crm';
exports.CRM = CRM;
var CALLING = 'calling';
exports.CALLING = CALLING;
var COMMUNICATOR = 'communicator';
exports.COMMUNICATOR = COMMUNICATOR;
var SETTINGS = 'settingsui';
exports.SETTINGS = SETTINGS;
var LISTS = 'lists';
exports.LISTS = LISTS;
var QUOTES = 'quotes-admin';
exports.QUOTES = QUOTES;
var PRODUCTS = 'products';
exports.PRODUCTS = PRODUCTS;
var LINEITEMS = 'line-items';
exports.LINEITEMS = LINEITEMS;
var REPORTING = 'reporting';
exports.REPORTING = REPORTING;